<app-form-cache-grid
    [option]="itemsSelectBoxOption"
    [code]="formCacheMode"
    [label]="label"
    (appFormValue)="addItem($event)">
</app-form-cache-grid>
